import React, { ErrorInfo } from "react"
import Bugsnag from "@bugsnag/js"
import { Button } from "../uiKit/Button/Button"
import { logToBugsnag } from "../../bugsnag/bugsnag"
import { logger } from "../../utils/loggerWrap"

class ErrorBoundary extends React.Component<any, { hasError: boolean }> {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        logger.error("Error (componentDidCatch)", { errorInfo: errorInfo }, error)
        if (logToBugsnag) {
            Bugsnag.notify(error, event => {
                event.severity = "error"
                event.unhandled = true
                event.addMetadata("react", { componentStack: errorInfo.componentStack })
            })
        }
    }

    errorContent = () => (
        <div className={classes.wrap}>
            <div>
                <h6 className={classes.title}>Something went wrong...</h6>
                <div className={classes.text}>
                    There was an unexpected error. Please try again or contact us at{" "}
                    <a href="mailto:support@figure.dev" className={classes.email}>
                        support@figure.dev
                    </a>
                </div>
                <Button className={classes.btn} size="large" onClick={() => location.reload()}>
                    Reload & Try again
                </Button>
            </div>
        </div>
    )

    render() {
        return this.state.hasError ? this.errorContent() : this.props.children
    }
}

const classes = {
    wrap: "align-center mx-auto flex h-screen w-full max-w-sm flex-col justify-center pb-8",
    title: "text-24 font-bold",
    text: "text-15",
    btn: "mt-4",
    email: "text-black/80 underline",
}

export default ErrorBoundary
